import React, { useEffect, useRef, useCallback, useMemo } from "react";
import { CircularProgress } from "@material-ui/core";
import { s360ConfigService } from "../Services/S360Config";
import Message from "./MessageBoxTypes/Message";
import "./ConversationStyleSheet.css";

const Conversation = React.memo(
  function ConversationComponent(props) {
    const messages = props.messages || [];

    const isFetchingMessages = props.isFetchingMessages || false;
    const isFullScreen = localStorage.getItem("openInFullScreen");
    const customDesign = props.config?.customDesign ?? {};
    const scrollRef = useRef(null);
    const downloadInProgress = props.downloadInProgress;

    const debouncedScroll = function (callback, delay) {
      let timer;

      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
          callback(...args);
        }, delay);
      };
    };
    useEffect(() => {
      if (
        messages.length > 0 &&
        messages[messages?.length - 1]?.userType === "BOT"
      ) {
        setTimeout(() => {
          scrollRef?.current?.scrollIntoView({
            behavior: "smooth",
            inline: "nearest",
          });
        }, 1000);
      } else {
        setTimeout(() => {
          scrollRef?.current?.scrollIntoView({
            behavior: "smooth",
            inline: "nearest",
          });
        }, 100);
      }
    }, [messages]);

    const pdfSpecificConvChatStyle = {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      paddingLeft: "200px",
      paddingRight: "200px",
    };

    return (
      <div
        className={`s360-conversation${isFullScreen ? "-fs" : ""}`}
        id="s360-conversation-chat"
        key="s360-conversation-chat"
        style={downloadInProgress ? pdfSpecificConvChatStyle : {}}
        ref={props.pdfRef}
      >
        {/* {messages.length === 0 && <ThreeDotLoading />} */}
        {messages.map((message, index) => {
          const object = {
            uploadFilesToPreview: props.uploadFilesToPreview,
            showTextBox: s360ConfigService.config.preview
              ? props.showTextBox
              : () => {},
            ...props,
            sendMessageToPreview: props.sendMessageToPreview,
            message: message,
            isLatestMessage: index === messages.length - 1,
            startNewConversation: props.startNewConversation,
            handleCustomerRetryMsg: props.handleCustomerRetryMsg,
            allAttachments: message.attachments ? message.attachments : [],
            workitemId: message.workitemId,
            createdAt: message.createdAt,
            ticketId: message?.parentTicketId
          };
          const showReceipt =
            s360ConfigService.config.configDetails?.showReadReceipt;
          return (
            <Message
              sandBoxedAgentInfo={props.sandBoxedAgentInfo}
              sandBoxedReadreciept={props.sandBoxedReadreciept}
              agentSandBoxInfo={props.agentSandBoxInfo}
              handleDeleteMessage={props.handleDeleteMessage}
              onEditMessage={props.onEditMessage}
              isAiBot={props.isAiBot}
              setShowInputBox={props.setShowInputBox}
              setEnableAttachmentProp={props.setEnableAttachmentProp}
              setFileParamsProp={props.setFileParamsProp}
              setInputSpecsProp={props.setInputSpecsProp}
              messageID={message?.id}
              key={`${message?.id || 'msg'}-${index}`}
              {...object}
              {...props}
              id={message?.id}
              showReadReceipt={showReceipt}
              enableAttachment={props.enableAttachment}
              lastMessageIndex={messages[messages.length - 1].id}
              currentMessageIndex={index}
              allAttachments={object.allAttachments}
              workitemId={object.workitemId}
              downloadInProgress={downloadInProgress}
              isLatestMessage={object.isLatestMessage}
              hideInputForHisry={props.hideInputForHisry}
              isEdited={message?.isEdited}
              isDeleted={message?.isDeleted}
              fromHistory={props?.fromHistory}
              ticketId={object?.ticketId}
              sessionId={props?.activeConversation?.sessionId}
            />
          );
        })}
        <div ref={scrollRef} className="scrollRef" />
      </div>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.isFetchingMessages === nextProps.isFetchingMessages &&
      prevProps.downloadInProgress === nextProps.downloadInProgress &&
      JSON.stringify(prevProps.config) === JSON.stringify(nextProps.config) &&
      prevProps.messages === nextProps.messages &&
      prevProps.hideInputForHisry === nextProps.hideInputForHisry &&
      prevProps.agentSandBoxInfo === nextProps.agentSandBoxInfo &&
      prevProps.sandBoxedReadreciept === nextProps.sandBoxedReadreciept &&
      prevProps.sandBoxedAgentInfo === nextProps.sandBoxedAgentInfo
    );
  }
);

export default Conversation;
